export default __webpack_public_path__ + "static/media/test-camera.ee9373c3.svg";